<template>
  <div>
    <header-component
      title="
      Verificando mi certificación
      "
      map="false"
    />
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="h2Title">Verificar mi certificación</h2>
          <p>Por favor, ingrese el código de su certificación.</p>
          <b-field label-position='on-border'>
            <b-input
              placeholder="Mi código"
              v-model="codigo"
            ></b-input>
            <b-button @click="consultar()"  type="is-primary">Consultar</b-button>
          </b-field>
          <b-field label="Contenido de mi documento">
            <b-input
              v-model="cuerpoDocumento"
              readonly
              maxlength="200"
              type="textarea"
            >
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*<img src="{{asset('img/notariaVilca.jpg')}}" />*/
import HeaderComponent from "@/components/HeaderComponent.vue";
export default {
  components: {
    HeaderComponent,
  },
  mounted() {
    console.log("Example Component mounted.");
    // this.confirmUser();
  },
  methods: {
    consultar() {
      this.$http
        .post(this.$store.state.url + "/api/consulta", { codigo: this.codigo })
        .then((response) => {
          console.log(response);
          if (response.data.success && response.data.success.documento) {
            this.cuerpoDocumento = response.data.success.documento;
          }
        });
    },
    confirmUser() {
      this.$buefy.dialog.confirm({
        title: "Usuario no registrado",
        message: `Para poder iniciar consultas en linea es necesario que se registre.`,
        confirmText: "Registrarme",
        cancelText: "Seguir sin registro",
        type: "is-warning",
        hasIcon: true,
        icon: "card-account-details",
        onConfirm: () => this.$buefy.toast.open("User agreed"),
      });
    },
  },
  data() {
    return {
      codigo: "",
      isActive: true,
      imgHome: process.env.MIX_APP_URL + "img/notariaVilca.jpg",
      cuerpoDocumento:
        "El contenido de mi documento aparecera aqui. Recuerde que solo tiene 3 consultas por dia.",
    };
  },
};
</script>
